import React from 'react';
import PropTypes from 'prop-types';

const CircleArrowIcon = ({ color, height, width }) => {
  return (
    <svg
      height={height}
      width={width}
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      x="0px"
      y="0px"
      viewBox="0 0 100 100"
      role="img"
    >
      <title>Circle with arrow in center</title>
      <path className="st0" d="M177.4,54.8" />
      <g>
        <polygon points="73.2,50 53.5,30.3 51,32.8 66.3,48.2 29.8,48.2 29.8,51.8 66.3,51.8 51,67.2 53.5,69.7  " />
        <g>
          <path d="M12.7,50.1c0-20.7,16.8-37.6,37.6-37.6s37.5,16.8,37.5,37.6S70.9,87.6,50.2,87.6S12.7,70.8,12.7,50.1z M84.2,50.1    c0-18.7-15.3-34-34-34s-34,15.3-34,34s15.3,34,34,34S84.2,68.8,84.2,50.1z" />
        </g>
      </g>
    </svg>
  );
};

export default CircleArrowIcon;

CircleArrowIcon.propTypes = {
  color: PropTypes.string.isRequired,
  height: PropTypes.string.isRequired,
  width: PropTypes.string.isRequired,
};
